<template>
    <div>
        <label v-if="!!label" :for="id">{{ label }}</label>
        <b-form-checkbox
            v-bind="$attrs"
            v-on="$listeners"
            :id="id"
            @input="$emit('input', value)"
            @change="$emit('change', value)"
            :value="value"
            :unchecked-value="uncheckedValue"
            ><slot></slot
        ></b-form-checkbox>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
        },
        id: {
            type: String,
            default: () => `checkbox-${parseInt(Math.random() * 100000000)}`,
        },
        value: {
            default: true,
        },
        uncheckedValue: {
            default: false,
        },
    },
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
